import { createReducer, INITIAL_STATE } from '../../../shared/redux';
import { buildApiConfig } from './subscription.api';
import { LOAD_STATE } from '../../../shared/axios';
import { Subscription } from './subscription.types';

export const GET_SUBSCRIPTION_REQUEST_CALLED = '@billing/subscription/GET_SUBSCRIPTION_REQUEST_CALLED';
export const GET_SUBSCRIPTION_REQUEST_SUCCEEDED = '@billing/subscription/GET_SUBSCRIPTION_REQUEST_SUCCEEDED';
export const GET_SUBSCRIPTION_REQUEST_FAILED = '@billing/subscription/GET_SUBSCRIPTION_REQUEST_FAILED';
export const UPDATE_SUBSCRIPTION = '@billing/subscription/UPDATE_SUBSCRIPTION';

export interface SubscriptionState {
    loadState: string,
    data: Subscription,
    error: any,
}

export const getSubscriptionData = state => state.billing.subscription.data;

export const getSubscription = () => ({
    type: GET_SUBSCRIPTION_REQUEST_CALLED,
    actionTypes: {
        success: GET_SUBSCRIPTION_REQUEST_SUCCEEDED,
        fail: GET_SUBSCRIPTION_REQUEST_FAILED,
    },
    config: buildApiConfig('GET'),
});

const initialState = {
    loadState: LOAD_STATE.LOADING,
    data: {},
    error: null,
};

export const updateSubscription = ({ subscription }) => ({
    type: UPDATE_SUBSCRIPTION,
    payload: {
        subscription,
    },
});

export const subscriptionReducers = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_SUBSCRIPTION_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
    }),
    [GET_SUBSCRIPTION_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: action.payload.data,
    }),
    [GET_SUBSCRIPTION_REQUEST_FAILED]: state => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: null,
    }),
    [UPDATE_SUBSCRIPTION]: (state, action) => ({
        ...state,
        data: {
            ...action.payload.subscription,
        },
    }),
});
